// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ValidationErrorSchema } from './v1/validationErrorSchema';
import { v1WebhookSchema } from './v1/webhookSchema';
import { v1WebhooksCreateSchema } from './v1/webhooks/createSchema';

export const createWebhookPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const createWebhookHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Webhook created successfully
 */
export const createWebhook201Schema = z.lazy(() => v1WebhookSchema);

/**
 * @description Validation errors
 */
export const createWebhook422Schema = z.lazy(() => v1ValidationErrorSchema);

export const createWebhookMutationRequestSchema = z.lazy(() => v1WebhooksCreateSchema);

export const createWebhookMutationResponseSchema = z.lazy(() => createWebhook201Schema);
